(() => {
  const buttonTimers = new WeakMap();
  const cartCountSelector =
    '[data-islander-cart-link] .cart-count-bubble, #cart-icon-bubble .cart-count-bubble';
  const productButtonSelector = '[data-islander-native-submit][data-islander-variant-id]';
  let refreshPromise = null;
  let refreshQueued = false;

  const clearTimer = (timer) => {
    if (timer && typeof window.clearTimeout === 'function') window.clearTimeout(timer);
  };

  const renderButtonQuantity = (button, quantity) => {
    if (!button) return;

    const normalizedQuantity = Math.max(0, Number(quantity) || 0);
    const label = button.querySelector?.('[data-islander-cart-quantity-label]');
    const value = label?.querySelector?.('[data-islander-cart-quantity-value]');

    button.dataset.islanderCartQuantity = String(normalizedQuantity);
    if (value) value.textContent = String(normalizedQuantity);
    if (label) label.hidden = normalizedQuantity < 1 || button.disabled;
  };

  const updateFromCart = (cart) => {
    const quantities = new Map();
    (cart?.items || []).forEach((item) => {
      const variantId = String(item.variant_id ?? item.id ?? '');
      const quantity = Math.max(0, Number(item.quantity) || 0);
      quantities.set(variantId, (quantities.get(variantId) || 0) + quantity);
    });

    document.querySelectorAll(productButtonSelector).forEach((button) => {
      const variantId = String(button.dataset.islanderVariantId || '');
      renderButtonQuantity(button, quantities.get(variantId) || 0);
    });
  };

  const refreshCart = () => {
    if (refreshPromise) {
      refreshQueued = true;
      return refreshPromise;
    }

    if (typeof window.fetch !== 'function') return Promise.resolve();
    const cartUrl = window.routes?.cart_url || '/cart';
    const request = window
      .fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to refresh cart quantity');
        return response.json();
      })
      .then(updateFromCart)
      .catch(() => undefined);

    refreshPromise = request.finally(() => {
      refreshPromise = null;
      if (refreshQueued) {
        refreshQueued = false;
        refreshCart();
      }
    });

    return refreshPromise;
  };

  const handleVariantChange = (event) => {
    const sectionId = event?.data?.sectionId;
    const html = event?.data?.html;
    if (!sectionId || !html) return;

    const buttonId = `ProductSubmitButton-${sectionId}`;
    const currentButton = document.getElementById?.(buttonId);
    const updatedButton = html.getElementById?.(buttonId);
    if (!currentButton || !updatedButton) return;

    currentButton.dataset.islanderVariantId = updatedButton.dataset.islanderVariantId || '';
    renderButtonQuantity(currentButton, updatedButton.dataset.islanderCartQuantity);
  };

  const confirm = (button) => {
    if (!button) return;

    clearTimer(buttonTimers.get(button));
    button.classList.add('is-added');

    const scope = button.closest?.('product-form') || button.parentElement || button;
    const status = scope.querySelector?.('[data-islander-added-status]');
    if (status) status.textContent = 'Added to bag';

    document.querySelectorAll(cartCountSelector).forEach((count) => {
      count.classList.remove('is-islander-cart-pulsing');
      window.requestAnimationFrame(() => count.classList.add('is-islander-cart-pulsing'));
      window.setTimeout(() => count.classList.remove('is-islander-cart-pulsing'), 360);
    });

    const resetTimer = window.setTimeout(() => {
      button.classList.remove('is-added');
      if (status) status.textContent = '';
      buttonTimers.delete(button);
    }, 1100);

    buttonTimers.set(button, resetTimer);
  };

  document.querySelectorAll(productButtonSelector).forEach((button) => {
    renderButtonQuantity(button, button.dataset.islanderCartQuantity);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
    subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
  }

  window.addEventListener?.('pageshow', (event) => {
    if (event.persisted) refreshCart();
  });

  window.IslanderCommerceFeedback = Object.freeze({ confirm, refreshCart, updateFromCart });
})();
